// extracted by mini-css-extract-plugin
export default {"action":"Action_action__Bk9-Z","action_button":"Action_action_button__pE5eu"};